import { ZoomIn, ZoomOut } from 'lucide-react';
import { Button } from '../../button/button';
import { Inline } from '../../inline/inline';

type ZoomControlsProps = {
  isZoomOutDisabled: boolean;
  onZoomIn: () => void;
  onZoomOut: () => void;
};

export const ZoomControls = ({ isZoomOutDisabled, onZoomIn, onZoomOut }: ZoomControlsProps) => {
  return (
    <Inline justify="between" className="rounded-full bg-muted p-2">
      <Button variant="ghost" size="none" className="rounded-none" onClick={onZoomIn}>
        <Inline space={1}>
          <div className="h-4 w-4 overflow-clip">
            <ZoomIn className="h-full w-full text-black" />
          </div>

          <p className="text-xs font-medium text-black">Zoom In</p>
        </Inline>
      </Button>

      <div className="h-4 w-px bg-border"></div>

      <Button variant="ghost" size="none" className="rounded-none" disabled={isZoomOutDisabled} onClick={onZoomOut}>
        <Inline space={1}>
          <div className="h-4 w-4 overflow-clip">
            <ZoomOut className="h-full w-full text-black" />
          </div>

          <p className="text-xs font-medium text-black">Zoom Out</p>
        </Inline>
      </Button>
    </Inline>
  );
};
